<template>
  <section class="block block-blue">
    <div class="home-block group group--first-last-small">
      <span class="mt-2" v-for="(block, index) in content" :key="index">
        <h3 class="h3">{{ block.title }}</h3>
        <p class="p mw-100">{{ block.body }}</p>
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: `blue-call-to-action`,
  data() {
    return {
      content: [
        {
          title: `Not Enough Information?`,
          body: `With some items, the reviewer may have indicated the x-ray does not have enough information to ` +
                `confirm the specific criteria. This can be because a poor x-ray image was taken. It can also ` +
                `happen when the angle of the image makes it difficult to see some things. For example, an ` +
                `additional canal may be hidden behind one or the access opening can be hidden by the crown. ` +
                `In these cases an additional image may be needed. Some dental offices have more advanced ` +
                `machines that take a comprehensive 3D image to make sure nothing is missed.  `,
        },
        {
          title: `What Next?`,
          body: `It's important to understand that your review is a comparison of the submitted x-rays ` +
                `against industry standards. If your report looks positive, then you now have an additional ` +
                `data point to help you appreciate the quality of work provided. If you’re report appears to show ` +
                `some issues, we recommend you start by discussing this with your dentist. He/She may know about ` +
                `your case beyond what your VeriTooth reviewer was able to see in the submitted x-rays. Dentists ` +
                `spend years perfecting their trade and care deeply about the quality of their work. In our ` +
                `conversations with dentists, most welcome the discussion and appreciate their patients ` +
                `taking an interest in quality work.  `,
        },
      ],
    };
  },
};
</script>

<style scoped>
h3.h3 {
  color: #FFFFFF;
}

.block-blue {
  background-color: #003A70;
  color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// BlueCallToAction.vue?735b1072